/**
 * Auth service — single place that turns credentials into a session.
 *
 * Mirrors the content service (src/lib/apiClient.js): when REACT_APP_API_URL is
 * UNSET it runs in demo mode (no backend), and when SET it POSTs to the real
 * API. Wiring the real backend therefore needs zero component changes — just
 * set the env var (see .env.example) and make the API return { user, token }.
 */

const API_BASE = process.env.REACT_APP_API_URL || "";

export async function signIn({ username, password }) {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) throw new Error("Invalid username or password.");
    return res.json(); // expected shape: { user, token }
  }

  // Demo mode — no backend yet. Accept any non-empty credentials.
  if (!username.trim() || !password.trim()) {
    throw new Error("Enter your username and password.");
  }
  return {
    token: "demo-token",
    user: {
      username,
      name: "Prof. Shahanara Begum",
      role: "Principal · Admin",
      initials: "SB",
    },
  };
}
